<template>
  <div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>기본정보</h5></vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">사업장명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_1"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">소속</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_0 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_0"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">부서</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_2"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작성자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <ml-input
            v-else
            class="w-full flex-1"
            v-model="form.inputA_3"
            :readonly="true"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">작성일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_4 }}</p>
          <date-selector
            v-model="form.inputA_4"
            v-else
            class="w-full flex-1"
            :readonly="board.readonly"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
        ><h5><i class="dot"></i>사고내용</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">일시</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <date-selector
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_1"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_2"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">사고실험실(팀)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_3"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">사고실험실(실험실)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_4"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">사고종류</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_5"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">재해형태</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <disaster-class-selector
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_6"
          />
        </div>
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">사고내용</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputB_7 }}</p>
          <ml-textarea
            placeholder="6하 원칙에 따라 약술"
            :readonly="board.readonly"
            v-else
            class="flex-1 w-full"
            rows="5"
            v-model="form.inputB_7"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">피해자 소속</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_8 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_8"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">피해자 성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_9 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_9"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">목격자 소속</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_10 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_10"
          />
        </div>
        <div class="col-span-6 flex items-center">
          <div class="label-text mr-4">목격자 성명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_11 }}</p>
          <ml-input
            :readonly="board.readonly"
            v-else
            class="w-full flex-1"
            v-model="form.inputB_11"
          />
        </div>
      </div>
    </div>
    <div class="mt-component-form">
      <vs-row class="my-4">
        <vs-col
        ><h5><i class="dot"></i>조치내용</h5></vs-col
        >
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">조치내용</div>
          <p v-if="isPrint" class="print-textarea">{{ form.inputC_1 }}</p>
          <ml-textarea
            :readonly="board.readonly"
            v-else
            class="flex-1 w-full"
            rows="7"
            v-model="form.inputC_1"
            placeholder="- 응급조치 내용
  • 인공호흡 후, △△병원 응급실로 후송
- 치료내용
  • 병원명 :
  • 동행한 사람 :
  • 세부 치료내용 등을 기술"
          />
        </div>
      </div>
    </div>
    <file-upload-module
      :readonly="board.readonly"
      class="w-full mt-4"
      v-if="!isPrint"
      v-model="form.fileList"
      :isPrint="isPrint"
    />
  </div>
</template>

<script>
import DateSelector from '@/components/selector/DateSelector.vue'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector.vue'
import TimeSelector from '@/components/selector/TimeSelector.vue'
import FileUploadModule from '@/views/modules/FileUploadModule.vue'

export default {
  name: 'Write',
  components: {
    FileUploadModule,
    DateSelector,
    TimeSelector,
    DisasterClassSelector
  },
  props: {
    board: Object,
    value: Object,
    isPrint: {
      type: Boolean
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {
        this.form.inputA_1 = this.value && this.value.inputA_1 ? this.value.inputA_1 : this.board.projectTitle
        this.form.inputA_2 = this.value && this.value.inputA_2 ? this.value.inputA_2 : this.board.writer.section
        this.form.inputA_3 = this.value && this.value.inputA_3 ? this.value.inputA_3 : this.board.writer.name
        this.form.inputA_0 =  this.value && this.value.inputA_0 ? this.value.inputA_0 : this.board.writer.department
      }
    },
    value (value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        this.form[key] = value[key]
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_1
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      form: {
        inputA_0: '',
        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',

        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',
        inputB_5: '',
        inputB_6: '',
        inputB_7: '',
        inputB_8: '',
        inputB_9: '',
        inputB_10: '',
        inputB_11: '',

        inputC_1: '',
        fileList: []
      },
    }
  }
}
</script>

<style scoped>
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 16px;
}

.mt-component-form {
  margin-top: 20px;
}
</style>
